/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/developer_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/developer_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  id: common.objectId,
  email: z.string().nullable().optional(),
  first_name: z.string().nullable().optional(),
  last_name: z.string().nullable().optional(),
  image_url: z.string().nullable(),
  last_signed_in_at: z.int().nullable(),
  internal_role: z
    .enum([
      "account_manager",
      "account_manager_admin",
      "admin",
      "alliance",
      "alliance_admin",
      "audit_admin",
      "business_intelligence",
      "devops",
      "devops_admin",
      "engineering",
      "engineering_admin",
      "engineering_with_oncall",
      "growth",
      "growth_admin",
      "growth_engineer",
      "integration",
      "integration_admin",
      "marketing",
      "marketing_admin",
      "partner",
      "partner_admin",
      "product",
      "product_admin",
      "provisioning_ops",
      "provisioning_ops_admin",
      "revenue_ops",
      "revenue_ops_admin",
      "robot",
      "sales",
      "sales_admin",
      "segments_export",
      "smsops",
      "smsops_admin",
      "solcon",
      "solcon_admin",
      "solcon_eu",
      "success",
      "success_admin",
      "success_eu",
      "success_impersonation_account",
      "success_read_only_impersonation_account",
      "support",
      "support_admin",
      "support_engineer",
      "support_eu",
      "support_sme",
      "technical_account_manager",
      "technical_account_manager_admin",
    ])
    .nullable(),
  is_company_admin: z.boolean().nullable().optional(),
  is_impersonation_user: z.boolean().nullable().optional(),
  is_suspended: z.boolean().nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/developer_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  id: common.objectId,
  email: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  image_url: z.string().nullable(),
  last_signed_in_at: z.int().nullable(),
  internal_role: z
    .enum([
      "account_manager",
      "account_manager_admin",
      "admin",
      "alliance",
      "alliance_admin",
      "audit_admin",
      "business_intelligence",
      "devops",
      "devops_admin",
      "engineering",
      "engineering_admin",
      "engineering_with_oncall",
      "growth",
      "growth_admin",
      "growth_engineer",
      "integration",
      "integration_admin",
      "marketing",
      "marketing_admin",
      "partner",
      "partner_admin",
      "product",
      "product_admin",
      "provisioning_ops",
      "provisioning_ops_admin",
      "revenue_ops",
      "revenue_ops_admin",
      "robot",
      "sales",
      "sales_admin",
      "segments_export",
      "smsops",
      "smsops_admin",
      "solcon",
      "solcon_admin",
      "solcon_eu",
      "success",
      "success_admin",
      "success_eu",
      "success_impersonation_account",
      "success_read_only_impersonation_account",
      "support",
      "support_admin",
      "support_engineer",
      "support_eu",
      "support_sme",
      "technical_account_manager",
      "technical_account_manager_admin",
    ])
    .nullable(),
  is_company_admin: z.boolean(),
  is_impersonation_user: z.boolean(),
  is_suspended: z.boolean(),
});
